import React from "react";
import "./global/global.css";
import { Grid } from "@material-ui/core";
import DashboardCard from "./global/components/DashboardCard.js";
import SettingsIcon from "./assets/settings.png";
import myProfileIcon from "./assets/myProfile.png";

const adminDashboardCardData = [
  {
    icon: myProfileIcon,
    iconAlt: "User Management",
    title: "User Management",
    description: "Send invitations and manage user subscriptions.",
    link: "/admin/users",
    agentType: "Admin",
    beta: false,
  },
  {
    icon: SettingsIcon,
    iconAlt: "Zillow Listing",
    title: "Zillow Listing",
    description:
      "Zillow Rental Manager setup instructions for pending listings.",
    link: "/admin/hitl/zillow",
    agentType: "Admin",
    beta: false,
  },
  {
    icon: SettingsIcon,
    iconAlt: "Analytics",
    title: "Analytics",
    description: "View user activity, DPM progression, and engagement metrics.",
    link: "/admin/analytics",
    agentType: "Admin",
    beta: false,
  },
  {
    icon: SettingsIcon,
    iconAlt: "Site Configuration",
    title: "Site Configuration",
    description: "Toggle runtime settings like email approval without a deploy.",
    link: "/admin/site-config",
    agentType: "Admin",
    beta: false,
  },
];

const AdminDashboard = () => {
  return (
    <>
      <div className="dashboard-root">
        <div className="db-container">
          <div className="dashboard">
            <div className="dashboard-container">
              <div className="dashboard-content">
                <h3>Admin Dashboard</h3>
                <p>
                  <span style={{ color: "#707070" }}>
                    Manage users, review submissions, and oversee platform operations
                  </span>{" "}
                  —{" "}
                  <span style={{ color: "#707070" }}>all from here.</span>
                </p>
              </div>
              <Grid container spacing={3}>
                {adminDashboardCardData.map((card, index) => (
                  <Grid item xs={12} sm={6} md={6} lg={4} xl={4} key={index}>
                    <DashboardCard
                      icon={card.icon}
                      title={card.title}
                      description={card.description}
                      link={card.link}
                      beta={card.beta}
                      agentType={card.agentType}
                    />
                  </Grid>
                ))}
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;